import { CurrentApiAndScopeEntitlementsDto } from '@portals/shared/portal/AppApiEntitlementDto';
import { ErrorContext } from '@portals/shared-frontend/hooks';
import { useContext } from 'react';

import PortalApiAccessFormModal from './components/PortalApiAccessFormModal';

interface Props {
  entitlement: CurrentApiAndScopeEntitlementsDto;
  onClose: () => void;
}

export default function RequestAccessToInternalApiModal({ entitlement, onClose }: Props) {
  const { setGlobalError } = useContext(ErrorContext);
  if (entitlement.api.enableServiceNowRequest) {
    setGlobalError(404);
    return null;
  }
  return <PortalApiAccessFormModal entitlement={entitlement} onClose={onClose} />;
}
